import RedirectModal from "@citizenm/foundation/components/RedirectModal/RedirectModal.vue";
import { MARRIOTT_REDIRECT_TIMEOUT } from "#shared/constants";

export default defineNuxtPlugin(() => {
  const { openModal, closeTopModal } = useModal();

  const redirectDomains = ["www.marriott.com"];

  document.addEventListener("click", (e) => {
    if (!(e.target instanceof HTMLElement)) {
      return;
    }

    const link = e.target.closest("a");

    if (!link) {
      return;
    }

    const isMarriottLink = redirectDomains.includes(link.hostname);

    if (isMarriottLink) {
      e.preventDefault();
      openModal(RedirectModal);
      setTimeout(() => {
        closeTopModal();
        window.open(link.href, "_self");
      }, MARRIOTT_REDIRECT_TIMEOUT);
    }
  });
});
